export default __webpack_public_path__ + "static/SRUS SB245 - Product Specifications & Technical Data-c105e8a7515dcb7006478f60e964007d.pdf";